import {FlexBox, useToasts, useIsMobile, useBreakpoint, CommonInput, INPUT_TYPES} from '@brg/ui';
import { MobileFilterSort } from 'shared/pages/explore/exploreView';
import { SortIcon } from 'shared/icons';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { Nullable, Project, GetProjectsByFilterProps } from '@brg/api';
import {LayoutConst, useModal} from '../../../core';
import {
  ActionsTitle,
  ActionsWrapper,
  MainTitle,
  ActionBottomButtons,
  ModalContainer,
  NoProjectWrapper, ProjectTabItem,
  SecondTitle
} from './styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import {useProjectsList} from "../../hooks/api/useProjectsByFilter";
import {DropdownTabs} from "../../pages/exploreHseContextsNew/components/DropdownTabs";
import {useTranslation} from "react-i18next";
import {useProfile} from "@brg/auth";
import {SearchInputComponent} from "../../components/SearchInput/SearchInputComponent";
import {Pagination} from "../../components/pagination";
import { useParams, useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';

enum SEND_PROJECT_TABS {
  projects = 'projects',
  presentations = 'presentations',
  bookmarks = 'bookmarks',
  find_projects = 'find_projects',
  selected_projects = 'selected_projects'
}

interface ISendProjectProps {
  alreadyProjects?: string[],
  project: Project,
  onSelectProjects?: (val: string[]) => void,
  maxProjects?: number,
  teamExtraFilter?: any,
  teamContexts?: string[],
  isPresentation?: boolean,
  hideBookmark?: boolean;
  status?: number,
  hideSearch?: boolean;
  contextsNotContains?: string[];
  onlyOnePresentation?: boolean;
  submitText?: string;
  descriptionText?: string;
  externalParams?: Record<string, any>;
  onlyAuthorProjects?: boolean;
}

export const SendProjectLongreadModal: FC<ISendProjectProps> = (props) => {

  const {
    alreadyProjects: alreadyProjectIds,
    onSelectProjects,
    maxProjects = 1,
    teamExtraFilter,
    status = undefined,
    teamContexts,
    onlyOnePresentation = true,
    onlyAuthorProjects,
    contextsNotContains,
    hideBookmark,
    hideSearch,
    externalParams,
    submitText,
    descriptionText,
    project
  } = props;

  const profile = useProfile()
  const [alreadyTime, setAlreadyTime] = useState(new Date().getTime())
  const [time, setT] = useState(new Date().getTime())
  const { t, i18n: { language } } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isLMS = AppTester.isLMSHSE();
  const [sorting, setSorting] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [activeTab, setActiveTab] = useState<string | SEND_PROJECT_TABS>(SEND_PROJECT_TABS.projects)
  const toasts = useToasts();
  const isMobile = useIsMobile()
  const is744BP = useBreakpoint(LayoutConst.screen.s)
  const modal = useModal();
  const isProjectEdit = useRouteMatch(LinkTo.projectEdit)?.params as Record<string, string>
  const [filterOpt, setFilterOpt] = useState<GetProjectsByFilterProps | null>(
      null
  )
  const [selectedProjects, setSelectedProjects] = useState<{id: string, isPresentation: boolean}[]>([])

  const currentProjectId = useMemo(() => (isProjectEdit?.id || undefined), [isProjectEdit]);

  const isEditing = (id: string) => {
    return id === currentProjectId
  }

  const [currentPage, setPage] = useState(1)
  const onPageChange = useCallback((page: any): void => {
    setPage(page)
    setFilterOpt(null)
    setT(Date.now())
  }, [])
  const onSend = useCallback(() => {
    const data = selectedProjects?.map((project: any) => project?.id)
    onSelectProjects && onSelectProjects(data)
    modal.hide()
  }, [onSelectProjects, selectedProjects])
  const is1440BP = useBreakpoint(LayoutConst.screen.s)

  const scrollTop = () => window.scrollTo(0, 0);

  const searchedId = useMemo(() => {
    const splittedText = searchText?.split('/');
    const lastPart = splittedText?.length > 0 ? splittedText[splittedText?.length - 1] : '';
    
    const idMatch = lastPart.match(/([a-f0-9]{32})$/i);
    return idMatch ? idMatch[1] : lastPart;
  }, [searchText])
  const isSearchLink = useMemo(() => {
    const splittedText = searchText?.split('/');
    return splittedText?.length > 1;
  }, [searchText])

  const noSelectedProjects = useMemo(() => selectedProjects?.length === 0 && activeTab === SEND_PROJECT_TABS.selected_projects, [searchText, activeTab])
  const noFindProjects = useMemo(() => !searchedId && activeTab === SEND_PROJECT_TABS.find_projects, [searchedId, activeTab])

  const [projects, isProjectsDefaultLoading, , projectsPaging] = useProjectsList(
    filterOpt,
    language,
    time,
    filterOpt === null
    || noSelectedProjects
    || noFindProjects
  )

  const [alreadyProjects, isProjectsAlreadyLoading, , projectsAlreadyPaging] = useProjectsList(
    // @ts-ignore
    {projectIds: alreadyProjectIds || [], isContextIgnored: true, ...(status ? {projectStatus: status} : {}), onlyBooks: ' '},
    language,
    alreadyTime,
    alreadyProjectIds?.length === 0
  )

  useEffect(() => {
    setSelectedProjects(alreadyProjects?.data?.map((project: any) => ({
      id: project?.projectId,
      isPresentation: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'].includes(project?.projectType)
    })) || [])
  }, [alreadyProjects])

  const isProjectsLoading = useMemo(() => isProjectsAlreadyLoading || isProjectsDefaultLoading, [isProjectsAlreadyLoading, isProjectsDefaultLoading])

  const coauthorsIds = useMemo(() => {
    if (!teamExtraFilter && project) {
      return project?.coAuthorIds
    }
    return []
  } , [project, teamExtraFilter])

  const authorsIds = useMemo(() => {
    if (!teamExtraFilter && project) {
      return [project?.authorId]
    }
    return []
  } , [project, teamExtraFilter])

  useEffect(() => {
    if (profile && profile?.accountId) {
      const baseFilters: any = {
        projectFilter: sorting,
        page: currentPage,
        limit: 8,
        projectStatus: [1],
        isContextIgnored: true,
        ...(currentProjectId ? { excludeProjectIds: [currentProjectId]} : {}),
        contextsNotContains: ['lmsproject', 'lmshseproject', ...(contextsNotContains || [])]
      }
      let defaultFilters: any = {
        ...baseFilters,
        onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks,
      }

      const additionalFilter = {
        ...(!!onlyAuthorProjects && activeTab !== SEND_PROJECT_TABS.find_projects ? { onlyAuthors: !!onlyAuthorProjects } : {}),
        ...(!!onlyAuthorProjects ? 
          //@ts-ignore
          { authorIds: [...new Set([...(coauthorsIds || []), ...(authorsIds || []) , profile?.accountId ])] } : 
          //@ts-ignore
          {authorOrCoAuthorIds:  [...new Set([...(coauthorsIds || []), ...(authorsIds || []) , profile?.accountId])]}),
      }

      const withoutTeamFilters = activeTab === SEND_PROJECT_TABS.selected_projects || activeTab === SEND_PROJECT_TABS.find_projects || activeTab === SEND_PROJECT_TABS.bookmarks;
      
      if (teamExtraFilter && !withoutTeamFilters) defaultFilters = {...defaultFilters, isContextIgnored: true, ...teamExtraFilter}
      else if ((teamContexts || [])?.length > 0 && !withoutTeamFilters) defaultFilters = {...defaultFilters, contexts: teamContexts, isContextIgnored: false, ...additionalFilter}
      else if (!withoutTeamFilters) defaultFilters = {...defaultFilters, ...additionalFilter }

      if (activeTab === SEND_PROJECT_TABS.bookmarks) defaultFilters = {...defaultFilters, page: currentPage, limit: 8, onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks, selectProjects: true }
      if (activeTab === SEND_PROJECT_TABS.projects) defaultFilters = {
        ...defaultFilters,
        ...additionalFilter,
        excludeProjectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'],
      }
      if (activeTab === SEND_PROJECT_TABS.presentations) defaultFilters = {
        ...defaultFilters,
        ...additionalFilter,
        projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'],
      }

      if (activeTab === SEND_PROJECT_TABS.selected_projects) defaultFilters = selectedProjects?.length ? { projectIds: selectedProjects?.map((project: any) => project?.id), page: currentPage, limit: 8, isContextIgnored: true } : null
      if (activeTab === SEND_PROJECT_TABS.find_projects && isSearchLink) defaultFilters = {
        projectFilter: sorting,
        page: currentPage, 
        limit: 8, 
        isContextIgnored: true, 
        projectIds: [searchedId],
        ...additionalFilter
      }
      if (activeTab === SEND_PROJECT_TABS.find_projects && !isSearchLink) defaultFilters = {
        projectFilter: sorting,
        page: currentPage, 
        limit: 8, 
        isContextIgnored: true, 
        search: searchText?.length > 2 ? [searchedId] : null, 
        ...additionalFilter
      }

      if (externalParams) {
        defaultFilters = {
          ...defaultFilters,
          ...externalParams
        }
      }

      setFilterOpt((defaultFilters)
      )
    }
  }, [profile, sorting, currentProjectId, contextsNotContains, currentPage, coauthorsIds, isSearchLink, onlyAuthorProjects, teamContexts, teamExtraFilter, activeTab, searchedId, isLMS])

  useEffect(() => {
    setT(Date.now())
  }, [activeTab, searchedId])

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
    onPageChange(1)
    setT(Date.now())
  }, [sorting, setSorting]);

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s)
    onPageChange(1)
    setT(Date.now())
  }, [])
  const onSelect = useCallback((project: Project | undefined): void => {

    // @ts-ignore
    const isPresentation = ['fixed-ratio-large', 't-shape', 'fixed-ratio-small'].includes(project?.projectType);

    if ((isPresentation || selectedProjects?.findIndex(selectedProjects => selectedProjects?.isPresentation) !== -1) && onlyOnePresentation) {
      setSelectedProjects([{id: project?.projectId || '', isPresentation}])
      return;
    }

    // @ts-ignore
    setSelectedProjects((prev: {id: string, isPresentation: boolean}[]) => {

      const includes = prev?.findIndex(selectedProjects => selectedProjects?.id === project?.projectId) !== -1

      if (includes)
        return prev.filter((a) => a?.id !== project?.projectId)
      if (prev?.length > (maxProjects - 1)) {
        toasts.error(t('competition.max_error') + ' ' + maxProjects);
        return prev;
      }
      return [...prev, {id: project?.projectId, isPresentation}]
    })
  }, [setSelectedProjects, selectedProjects, maxProjects, alreadyProjectIds,onlyOnePresentation])

  const searchBar = useMemo(
      () => (
          <ProjectsSearchBar
              isLoading={false}
              sorting={sorting}
              hideRightBar={false}
              hideLeftBar
              hideRightButtons
              onSortingChange={onSortingChange}
              isTagPage={false}
              projectCount={projects?.data?.length}
          />
      ),

      [sorting, onSortingChange, projects]
  )

  const tabNames = useMemo(() => {

    const extraTabs = (teamExtraFilter ? {
      ...(!hideBookmark && {[SEND_PROJECT_TABS.bookmarks]: t('send_projects.bookmarks')}),
      ...(!hideSearch && {[SEND_PROJECT_TABS.find_projects]: t('send_projects.find_projects')})
    } : {})

    return ({
      [SEND_PROJECT_TABS.projects]: t('send_projects.projects'),
      [SEND_PROJECT_TABS.presentations]: t('send_projects.presentations'),
      ...extraTabs,
      [SEND_PROJECT_TABS.selected_projects]: t('send_projects.selected_projects') + ' ' + selectedProjects?.length || 0
    })

  }, [selectedProjects, teamExtraFilter, hideBookmark, hideSearch, language])

  const MobileDropdownTabs = useMemo(() => {

    const extraTabs = (teamExtraFilter ? {
      ...(!hideBookmark && {[SEND_PROJECT_TABS.bookmarks]: t('send_projects.bookmarks')}),
      ...(!hideSearch && {[SEND_PROJECT_TABS.find_projects]: t('send_projects.find_projects')})
    } : {})

    return (
        <DropdownTabs
            whiteTheme={false}
            activeTabKey={activeTab}
            items={{
              [SEND_PROJECT_TABS.projects]: tabNames[SEND_PROJECT_TABS.projects],
              [SEND_PROJECT_TABS.presentations]: tabNames[SEND_PROJECT_TABS.presentations],
              ...extraTabs,
              [SEND_PROJECT_TABS.selected_projects]: tabNames[SEND_PROJECT_TABS.selected_projects]
            }}
            onChange={(tab: any) => {
              setActiveTab(tab)
            }}
        />
    )
  }, [activeTab, tabNames, teamExtraFilter, hideBookmark, language])

  const isNoProjects = useMemo(() => (!isProjectsLoading && (projects?.data?.length === 0 || !projects?.data)
          || (selectedProjects?.length === 0 && activeTab === SEND_PROJECT_TABS.selected_projects)
          || noSelectedProjects || noFindProjects),
      [!isProjectsLoading, projects, selectedProjects?.length, noSelectedProjects, noFindProjects])


  return (
    <ModalContainer style={{ overflow: 'auto', height: '100%'}} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      
        <FlexBox width={'100%'} directionMobile='column' justify={isMobile ? 'flex-start': 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative'}}>
            <ActionsWrapper direction="column" style={{ justifyContent: 'center', position: 'relative' }}>
                <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' >
                <FlexBox direction='column'>
                    <MainTitle>
                        {t(`competition.${maxProjects > 1 ? 'select_projects' : 'select_project'}`)}
                    </MainTitle>
                    {descriptionText && (
                      <SecondTitle>{descriptionText}</SecondTitle>
                    )}
                </FlexBox>
                {!is744BP && (
                  <FlexBox>
                    <SendProjectButton isGreen={isGeo} width={187} disabled={/*selectedProjects?.length === 0 || */selectedProjects?.length > maxProjects} onClick={onSend}>
                      {`${submitText || t('competition.send')}${selectedProjects?.length > 0 ? ` (${selectedProjects?.length})` : ''}`}
                    </SendProjectButton>
                  </FlexBox>
                )}
                </ActionsTitle>
                  <FlexBox
                      width={'100%'}
                      direction='row'
                      justify='space-between'
                      align='center'
                      offsetBottom={is1440BP ? 24 : 32}
                  >
                    {isMobile ? MobileDropdownTabs : <FlexBox gx={24}>
                      {Object.keys(tabNames).map((tabKey, index) => <ProjectTabItem isActive={activeTab == tabKey} key={index} onClick={() => setActiveTab(tabKey)}>
                        {/* @ts-ignore */}
                        {tabNames[tabKey]}
                      </ProjectTabItem>)}
                    </FlexBox>}
                    {isMobile ? (
                      <MobileFilterSort onClick={onMobileSortingClick}>
                        <SortIcon/>
                        {t(`sorting_type.${Number(sorting) === 1 ? 'latest' : 'popular'}`)}
                      </MobileFilterSort>
                    ) : searchBar}
                  </FlexBox>
              {activeTab === SEND_PROJECT_TABS.find_projects && <FlexBox width={"100%"} offsetBottom={24}>
                <CommonInput 
                  type={INPUT_TYPES.search}
                  onChange={(ev: any) => setSearchText(ev.target.value)}
                  value={searchText}
                  placeholder={t('send_projects.enter_link')}
                />
                </FlexBox>}
              {isNoProjects ? <NoProjectWrapper>{t('send_projects.nothing_found')}</NoProjectWrapper> : (
                   <ProjectsGridNew k={undefined} isLoading={isProjectsLoading}>
                   {projects?.data?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
                       return (
                          // @ts-ignore
                         <ProjectCardNew
                           project={v as any}
                           isModal={true}
                           withoutGoToProject={true}
                           onProjectClick={modal ?
                             (projectId?: string, e?: any) => {
                               e?.stopPropagation();
                               e?.preventDefault();
                             } : undefined}
                            isSelectable={true}
                           //@ts-ignore
                           isRejected={ProjectDelegate.isRejectedProject(v)}
                           key={(v?.projectId || '') + index}
                           {...computeProject(v)}
                          isSelectRightNeed={isMobile}
                          editingProject={isEditing(v?.projectId ?? '')}
                           metaAlwaysVisible
                           selectRingPosition={RingPositions.right}
                           onSelectProject={onSelect}
                           // @ts-ignore
                           selected={selectedProjects?.findIndex(selectedProject => selectedProject?.id === v?.projectId ?? '') !== -1}
                         />
                       );

                   })}
                 </ProjectsGridNew>
                )}
              {!isNoProjects && <Pagination
                  //@ts-ignore
                  pages={projectsPaging?.pages ?? 0}
                  page={Number(currentPage)}
                  isLoading={isProjectsLoading}
                  onPageChange={(page: any) => {
                    onPageChange(page)
                    setT(Date.now())
                    scrollTop()
                  }}
                  //@ts-ignore
                  isCanLoadMore={currentPage < (projectsPaging?.pages ?? 0)}
              />}
              {is744BP && (
                <ActionBottomButtons>
                    <SendProjectButton width={ isMobile ? 112 : 187}  disabled={/*selectedProjects?.length === 0 || */selectedProjects?.length > maxProjects} onClick={onSend}>
                      {`${submitText || t('competition.send')}${selectedProjects?.length > 0 ? ` (${selectedProjects?.length})` : ''}`}
                    </SendProjectButton>
                </ActionBottomButtons>
              )}
            </ActionsWrapper>
        </FlexBox>
    </ModalContainer>
  );
};
import {FlexBox, useToasts, useIsMobile, useBreakpoint, CommonInput, INPUT_TYPES} from '@brg/ui';
import { MobileFilterSort } from 'shared/pages/explore/exploreView';
import { SortIcon } from 'shared/icons';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { Nullable, Project, GetProjectsByFilterProps } from '@brg/api';
import {LayoutConst, useModal} from '../../../core';
import {
  ActionsTitle,
  ActionsWrapper,
  MainTitle,
  ActionBottomButtons,
  ModalContainer,
  NoProjectWrapper, ProjectTabItem,
  SecondTitle
} from './styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import {useProjectsList} from "../../hooks/api/useProjectsByFilter";
import {DropdownTabs} from "../../pages/exploreHseContextsNew/components/DropdownTabs";
import {useTranslation} from "react-i18next";
import {useProfile} from "@brg/auth";
import {SearchInputComponent} from "../../components/SearchInput/SearchInputComponent";
import {Pagination} from "../../components/pagination";
import { useParams, useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';

enum SEND_PROJECT_TABS {
  projects = 'projects',
  presentations = 'presentations',
  bookmarks = 'bookmarks',
  find_projects = 'find_projects',
  selected_projects = 'selected_projects'
}

interface ISendProjectProps {
  alreadyProjects?: string[],
  project: Project,
  onSelectProjects?: (val: string[]) => void,
  maxProjects?: number,
  teamExtraFilter?: any,
  teamContexts?: string[],
  isPresentation?: boolean,
  hideBookmark?: boolean;
  status?: number,
  hideSearch?: boolean;
  contextsNotContains?: string[];
  onlyOnePresentation?: boolean;
  submitText?: string;
  descriptionText?: string;
  externalParams?: Record<string, any>;
  onlyAuthorProjects?: boolean;
}

export const SendProjectLongreadModal: FC<ISendProjectProps> = (props) => {

  const {
    alreadyProjects: alreadyProjectIds,
    onSelectProjects,
    maxProjects = 1,
    teamExtraFilter,
    status = undefined,
    teamContexts,
    onlyOnePresentation = true,
    onlyAuthorProjects,
    contextsNotContains,
    hideBookmark,
    hideSearch,
    externalParams,
    submitText,
    descriptionText,
    project
  } = props;

  const profile = useProfile()
  const [alreadyTime, setAlreadyTime] = useState(new Date().getTime())
  const [time, setT] = useState(new Date().getTime())
  const { t, i18n: { language } } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isLMS = AppTester.isLMSHSE();
  const [sorting, setSorting] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [activeTab, setActiveTab] = useState<string | SEND_PROJECT_TABS>(SEND_PROJECT_TABS.projects)
  const toasts = useToasts();
  const isMobile = useIsMobile()
  const is744BP = useBreakpoint(LayoutConst.screen.s)
  const modal = useModal();
  const isProjectEdit = useRouteMatch(LinkTo.projectEdit)?.params as Record<string, string>
  const [filterOpt, setFilterOpt] = useState<GetProjectsByFilterProps | null>(
      null
  )
  const [selectedProjects, setSelectedProjects] = useState<{id: string, isPresentation: boolean}[]>([])

  const currentProjectId = useMemo(() => (isProjectEdit?.id || undefined), [isProjectEdit]);

  const isEditing = (id: string) => {
    return id === currentProjectId
  }

  const [currentPage, setPage] = useState(1)
  const onPageChange = useCallback((page: any): void => {
    setPage(page)
    setFilterOpt(null)
    setT(Date.now())
  }, [])
  const onSend = useCallback(() => {
    const data = selectedProjects?.map((project: any) => project?.id)
    onSelectProjects && onSelectProjects(data)
    modal.hide()
  }, [onSelectProjects, selectedProjects])
  const is1440BP = useBreakpoint(LayoutConst.screen.s)

  const scrollTop = () => window.scrollTo(0, 0);

  const searchedId = useMemo(() => {
    const splittedText = searchText?.split('/');
    const lastPart = splittedText?.length > 0 ? splittedText[splittedText?.length - 1] : '';
    
    const idMatch = lastPart.match(/([a-f0-9]{32})$/i);
    return idMatch ? idMatch[1] : lastPart;
  }, [searchText])
  const isSearchLink = useMemo(() => {
    const splittedText = searchText?.split('/');
    return splittedText?.length > 1;
  }, [searchText])

  const noSelectedProjects = useMemo(() => selectedProjects?.length === 0 && activeTab === SEND_PROJECT_TABS.selected_projects, [searchText, activeTab])
  const noFindProjects = useMemo(() => !searchedId && activeTab === SEND_PROJECT_TABS.find_projects, [searchedId, activeTab])

  const [projects, isProjectsDefaultLoading, , projectsPaging] = useProjectsList(
    filterOpt,
    language,
    time,
    filterOpt === null
    || noSelectedProjects
    || noFindProjects
  )

  const [alreadyProjects, isProjectsAlreadyLoading, , projectsAlreadyPaging] = useProjectsList(
    // @ts-ignore
    {projectIds: alreadyProjectIds || [], isContextIgnored: true, ...(status ? {projectStatus: status} : {}), onlyBooks: ' '},
    language,
    alreadyTime,
    alreadyProjectIds?.length === 0
  )

  useEffect(() => {
    setSelectedProjects(alreadyProjects?.data?.map((project: any) => ({
      id: project?.projectId,
      isPresentation: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'].includes(project?.projectType)
    })) || [])
  }, [alreadyProjects])

  const isProjectsLoading = useMemo(() => isProjectsAlreadyLoading || isProjectsDefaultLoading, [isProjectsAlreadyLoading, isProjectsDefaultLoading])

  const coauthorsIds = useMemo(() => {
    if (!teamExtraFilter && project) {
      return project?.coAuthorIds
    }
    return []
  } , [project, teamExtraFilter])

  const authorsIds = useMemo(() => {
    if (!teamExtraFilter && project) {
      return [project?.authorId]
    }
    return []
  } , [project, teamExtraFilter])

  useEffect(() => {
    if (profile && profile?.accountId) {
      const baseFilters: any = {
        projectFilter: sorting,
        page: currentPage,
        limit: 8,
        projectStatus: [1],
        isContextIgnored: true,
        ...(currentProjectId ? { excludeProjectIds: [currentProjectId]} : {}),
        contextsNotContains: ['lmsproject', 'lmshseproject', ...(contextsNotContains || [])]
      }
      let defaultFilters: any = {
        ...baseFilters,
        onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks,
      }

      const additionalFilter = {
        ...(!!onlyAuthorProjects && activeTab !== SEND_PROJECT_TABS.find_projects ? { onlyAuthors: !!onlyAuthorProjects } : {}),
        ...(!!onlyAuthorProjects ? 
          //@ts-ignore
          { authorIds: [...new Set([...(coauthorsIds || []), ...(authorsIds || []) , profile?.accountId ])] } : 
          //@ts-ignore
          {authorOrCoAuthorIds:  [...new Set([...(coauthorsIds || []), ...(authorsIds || []) , profile?.accountId])]}),
      }

      const withoutTeamFilters = activeTab === SEND_PROJECT_TABS.selected_projects || activeTab === SEND_PROJECT_TABS.find_projects || activeTab === SEND_PROJECT_TABS.bookmarks;
      
      if (teamExtraFilter && !withoutTeamFilters) defaultFilters = {...defaultFilters, isContextIgnored: true, ...teamExtraFilter}
      else if ((teamContexts || [])?.length > 0 && !withoutTeamFilters) defaultFilters = {...defaultFilters, contexts: teamContexts, isContextIgnored: false, ...additionalFilter}
      else if (!withoutTeamFilters) defaultFilters = {...defaultFilters, ...additionalFilter }

      if (activeTab === SEND_PROJECT_TABS.bookmarks) defaultFilters = {...defaultFilters, page: currentPage, limit: 8, onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks, selectProjects: true }
      if (activeTab === SEND_PROJECT_TABS.projects) defaultFilters = {
        ...defaultFilters,
        ...additionalFilter,
        excludeProjectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'],
      }
      if (activeTab === SEND_PROJECT_TABS.presentations) defaultFilters = {
        ...defaultFilters,
        ...additionalFilter,
        projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'],
      }

      if (activeTab === SEND_PROJECT_TABS.selected_projects) defaultFilters = selectedProjects?.length ? { projectIds: selectedProjects?.map((project: any) => project?.id), page: currentPage, limit: 8, isContextIgnored: true } : null
      if (activeTab === SEND_PROJECT_TABS.find_projects && isSearchLink) defaultFilters = {
        projectFilter: sorting,
        page: currentPage, 
        limit: 8, 
        isContextIgnored: true, 
        projectIds: [searchedId],
        ...additionalFilter
      }
      if (activeTab === SEND_PROJECT_TABS.find_projects && !isSearchLink) defaultFilters = {
        projectFilter: sorting,
        page: currentPage, 
        limit: 8, 
        isContextIgnored: true, 
        search: searchText?.length > 2 ? [searchedId] : null, 
        ...additionalFilter
      }

      if (externalParams) {
        defaultFilters = {
          ...defaultFilters,
          ...externalParams
        }
      }

      setFilterOpt((defaultFilters)
      )
    }
  }, [profile, sorting, currentProjectId, contextsNotContains, currentPage, coauthorsIds, isSearchLink, onlyAuthorProjects, teamContexts, teamExtraFilter, activeTab, searchedId, isLMS])

  useEffect(() => {
    setT(Date.now())
  }, [activeTab, searchedId])

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
    onPageChange(1)
    setT(Date.now())
  }, [sorting, setSorting]);

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s)
    onPageChange(1)
    setT(Date.now())
  }, [])
  const onSelect = useCallback((project: Project | undefined): void => {

    // @ts-ignore
    const isPresentation = ['fixed-ratio-large', 't-shape', 'fixed-ratio-small'].includes(project?.projectType);

    if ((isPresentation || selectedProjects?.findIndex(selectedProjects => selectedProjects?.isPresentation) !== -1) && onlyOnePresentation) {
      setSelectedProjects([{id: project?.projectId || '', isPresentation}])
      return;
    }

    // @ts-ignore
    setSelectedProjects((prev: {id: string, isPresentation: boolean}[]) => {

      const includes = prev?.findIndex(selectedProjects => selectedProjects?.id === project?.projectId) !== -1

      if (includes)
        return prev.filter((a) => a?.id !== project?.projectId)
      if (prev?.length > (maxProjects - 1)) {
        toasts.error(t('competition.max_error') + ' ' + maxProjects);
        return prev;
      }
      return [...prev, {id: project?.projectId, isPresentation}]
    })
  }, [setSelectedProjects, selectedProjects, maxProjects, alreadyProjectIds,onlyOnePresentation])

  const searchBar = useMemo(
      () => (
          <ProjectsSearchBar
              isLoading={false}
              sorting={sorting}
              hideRightBar={false}
              hideLeftBar
              hideRightButtons
              onSortingChange={onSortingChange}
              isTagPage={false}
              projectCount={projects?.data?.length}
          />
      ),

      [sorting, onSortingChange, projects]
  )

  const tabNames = useMemo(() => {

    const extraTabs = (teamExtraFilter ? {
      ...(!hideBookmark && {[SEND_PROJECT_TABS.bookmarks]: t('send_projects.bookmarks')}),
      ...(!hideSearch && {[SEND_PROJECT_TABS.find_projects]: t('send_projects.find_projects')})
    } : {})

    return ({
      [SEND_PROJECT_TABS.projects]: t('send_projects.projects'),
      [SEND_PROJECT_TABS.presentations]: t('send_projects.presentations'),
      ...extraTabs,
      [SEND_PROJECT_TABS.selected_projects]: t('send_projects.selected_projects') + ' ' + selectedProjects?.length || 0
    })

  }, [selectedProjects, teamExtraFilter, hideBookmark, hideSearch, language])

  const MobileDropdownTabs = useMemo(() => {

    const extraTabs = (teamExtraFilter ? {
      ...(!hideBookmark && {[SEND_PROJECT_TABS.bookmarks]: t('send_projects.bookmarks')}),
      ...(!hideSearch && {[SEND_PROJECT_TABS.find_projects]: t('send_projects.find_projects')})
    } : {})

    return (
        <DropdownTabs
            whiteTheme={false}
            activeTabKey={activeTab}
            items={{
              [SEND_PROJECT_TABS.projects]: tabNames[SEND_PROJECT_TABS.projects],
              [SEND_PROJECT_TABS.presentations]: tabNames[SEND_PROJECT_TABS.presentations],
              ...extraTabs,
              [SEND_PROJECT_TABS.selected_projects]: tabNames[SEND_PROJECT_TABS.selected_projects]
            }}
            onChange={(tab: any) => {
              setActiveTab(tab)
            }}
        />
    )
  }, [activeTab, tabNames, teamExtraFilter, hideBookmark, language])

  const isNoProjects = useMemo(() => (!isProjectsLoading && (projects?.data?.length === 0 || !projects?.data)
          || (selectedProjects?.length === 0 && activeTab === SEND_PROJECT_TABS.selected_projects)
          || noSelectedProjects || noFindProjects),
      [!isProjectsLoading, projects, selectedProjects?.length, noSelectedProjects, noFindProjects])


  return (
    <ModalContainer style={{ overflow: 'auto', height: '100%'}} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      
        <FlexBox width={'100%'} directionMobile='column' justify={isMobile ? 'flex-start': 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative'}}>
            <ActionsWrapper direction="column" style={{ justifyContent: 'center', position: 'relative' }}>
                <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' >
                <FlexBox direction='column'>
                    <MainTitle>
                        {t(`competition.${maxProjects > 1 ? 'select_projects' : 'select_project'}`)}
                    </MainTitle>
                    {descriptionText && (
                      <SecondTitle>{descriptionText}</SecondTitle>
                    )}
                </FlexBox>
                {!is744BP && (
                  <FlexBox>
                    <SendProjectButton isGreen={isGeo} width={187} disabled={/*selectedProjects?.length === 0 || */selectedProjects?.length > maxProjects} onClick={onSend}>
                      {`${submitText || t('competition.send')}${selectedProjects?.length > 0 ? ` (${selectedProjects?.length})` : ''}`}
                    </SendProjectButton>
                  </FlexBox>
                )}
                </ActionsTitle>
                  <FlexBox
                      width={'100%'}
                      direction='row'
                      justify='space-between'
                      align='center'
                      offsetBottom={is1440BP ? 24 : 32}
                  >
                    {isMobile ? MobileDropdownTabs : <FlexBox gx={24}>
                      {Object.keys(tabNames).map((tabKey, index) => <ProjectTabItem isActive={activeTab == tabKey} key={index} onClick={() => setActiveTab(tabKey)}>
                        {/* @ts-ignore */}
                        {tabNames[tabKey]}
                      </ProjectTabItem>)}
                    </FlexBox>}
                    {isMobile ? (
                      <MobileFilterSort onClick={onMobileSortingClick}>
                        <SortIcon/>
                        {t(`sorting_type.${Number(sorting) === 1 ? 'latest' : 'popular'}`)}
                      </MobileFilterSort>
                    ) : searchBar}
                  </FlexBox>
              {activeTab === SEND_PROJECT_TABS.find_projects && <FlexBox width={"100%"} offsetBottom={24}>
                <CommonInput 
                  type={INPUT_TYPES.search}
                  onChange={(ev: any) => setSearchText(ev.target.value)}
                  value={searchText}
                  placeholder={t('send_projects.enter_link')}
                />
                </FlexBox>}
              {isNoProjects ? <NoProjectWrapper>{t('send_projects.nothing_found')}</NoProjectWrapper> : (
                   <ProjectsGridNew k={undefined} isLoading={isProjectsLoading}>
                   {projects?.data?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
                       return (
                          // @ts-ignore
                         <ProjectCardNew
                           project={v as any}
                           isModal={true}
                           withoutGoToProject={true}
                           onProjectClick={modal ?
                             (projectId?: string, e?: any) => {
                               e?.stopPropagation();
                               e?.preventDefault();
                             } : undefined}
                            isSelectable={true}
                           //@ts-ignore
                           isRejected={ProjectDelegate.isRejectedProject(v)}
                           key={(v?.projectId || '') + index}
                           {...computeProject(v)}
                          isSelectRightNeed={isMobile}
                          editingProject={isEditing(v?.projectId ?? '')}
                           metaAlwaysVisible
                           selectRingPosition={RingPositions.right}
                           onSelectProject={onSelect}
                           // @ts-ignore
                           selected={selectedProjects?.findIndex(selectedProject => selectedProject?.id === v?.projectId ?? '') !== -1}
                         />
                       );

                   })}
                 </ProjectsGridNew>
                )}
              {!isNoProjects && <Pagination
                  //@ts-ignore
                  pages={projectsPaging?.pages ?? 0}
                  page={Number(currentPage)}
                  isLoading={isProjectsLoading}
                  onPageChange={(page: any) => {
                    onPageChange(page)
                    setT(Date.now())
                    scrollTop()
                  }}
                  //@ts-ignore
                  isCanLoadMore={currentPage < (projectsPaging?.pages ?? 0)}
              />}
              {is744BP && (
                <ActionBottomButtons>
                    <SendProjectButton width={ isMobile ? 112 : 187}  disabled={/*selectedProjects?.length === 0 || */selectedProjects?.length > maxProjects} onClick={onSend}>
                      {`${submitText || t('competition.send')}${selectedProjects?.length > 0 ? ` (${selectedProjects?.length})` : ''}`}
                    </SendProjectButton>
                </ActionBottomButtons>
              )}
            </ActionsWrapper>
        </FlexBox>
    </ModalContainer>
  );
};
